/**
 * `storePages.*` — the ERP composer's content-page surface (module 22).
 *
 * A page is a free-form title + body a seller authors and links from the
 * header/footer navigation. Slugs are generated server-side from the title at
 * creation and never sent on the wire — a link that targets a page keeps
 * resolving after the title is edited.
 */
import { z } from "zod";
import { uuid } from "../_common.js";

/** Draft is invisible to buyers; published is served at `/s/<store>/pages/<slug>`. */
export const pageStatus = z.enum(["draft", "published"]);
export type StorePageStatus = z.infer<typeof pageStatus>;

export const listPagesInput = z.object({});

export const listPagesOutput = z.object({
  items: z.array(
    z.object({
      id: uuid,
      slug: z.string(),
      title: z.string(),
      body: z.string(),
      status: pageStatus,
      createdAt: z.string(),
    }),
  ),
});

export const createPageInput = z.object({
  title: z.string().trim().min(1).max(120),
  body: z.string().max(20_000).default(""),
});

export const createPageOutput = z.object({ id: uuid, slug: z.string() });

export const updatePageInput = z.object({
  id: uuid,
  title: z.string().trim().min(1).max(120),
  body: z.string().max(20_000),
});

export const updatePageOutput = z.object({ ok: z.literal(true) });

export const setPageStatusInput = z.object({
  id: uuid,
  status: pageStatus,
});

export const setPageStatusOutput = z.object({ ok: z.literal(true) });
